export default "__VITE_ASSET__CkbTwl6f__"